import React from 'react';
import { Card as AntCard, Row as AntRow, Col as AntCol } from 'antd';
import { IoIosPeople } from 'react-icons/io';
import { SiBookstack } from 'react-icons/si';
import { BsListTask } from 'react-icons/bs';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Dashboard.css';
import { FaPlus } from 'react-icons/fa';
import { LiaClipboardListSolid } from 'react-icons/lia';
import { IoListSharp } from 'react-icons/io5';
import { GiExitDoor } from 'react-icons/gi';
import { HiArrowSmUp } from 'react-icons/hi';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { IoPerson } from 'react-icons/io5';
import { Calendar } from 'antd';
import { Link } from 'react-router-dom';
import Cases from '../Cases/Cases';

import { useNavigate } from 'react-router-dom';

const cardData = [
  {
    color: '#4BAEE1',
    icon: <IoIosPeople />,
    count: 4,
    label: 'Clients',
    route: '/clients',
  },
  {
    color: '#4CAF50',
    icon: <SiBookstack />,
    count: 5,
    label: 'Cases',
    route: '/cases',
  },
  {
    color: '#FF9800',
    icon: '⭐',
    count: 0,
    label: 'Starred Cases',
    route: '/cases',
  },
  {
    color: '#2196F3',
    icon: <IoIosPeople />,
    count: 4,
    label: 'Employees',
    route: '/employees',
  },
  {
    color: '#F44336',
    icon: <BsListTask />,
    count: 11,
    label: 'Tasks',
    route: 'https://taskpro.defconinnovations.com/kanbanboard',
    external: true, // add this flag
  },

  {
    color: '#F44336',
    icon: <BsListTask />,
    count: 11,
    label: 'AL-Othman',
    route: 'https://alothmanlaw.sa/en/',
    external: true, // add this flag
  },
  {
    color: '#F44336',
    icon: <BsListTask />,
    count: 11,
    label: 'Case Category',
    route: '/case-category',
  },
  {
    color: '#4BAEE1',
    icon: <SiBookstack />,
    count: 4,
    label: 'Case Study',
    route: '/case-study',
  },
];

const cards = [
  { title: 'Card 1', text: 'This is the first card.' },
  { title: 'Card 2', text: 'This is the second card.' },
  { title: 'Card 3', text: 'This is the third card.' },
  { title: 'Card 4', text: 'This is the fourth card.' },
];

const Dashboard = () => {
  const navigate = useNavigate();
  const handleTaskClick = () => {
    navigate('/cases');
  };
  const onPanelChange = (value, mode) => {
    console.log(value.format('YYYY-MM-DD'), mode);
  };
  const getRouteFromLabel = label => {
    return '/' + label.toLowerCase().replace(/\s+/g, '-');
  };

  return (
    <>
      <div className="container">
        <AntRow gutter={[16, 16]} className="dashboard-container">
          {cardData.map((item, index) => (
            <AntCol xs={24} sm={12} md={8} lg={6} key={index}>
              {item.external ? (
                <a
                  href={item.route}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`card-link card-${index}`}
                >
                  <AntCard className="dashboard-card">
                    <div className="card-content">
                      <div className="card-icon">{item.icon}</div>
                      <div className="card-text">
                        <h2>{item.count}</h2>
                        <p>{item.label}</p>
                      </div>
                      <div className="card-footer">More Info ➡</div>
                    </div>
                  </AntCard>
                </a>
              ) : (
                <Link
                  to={item.route || getRouteFromLabel(item.label)}
                  className={`card-link card-${index}`}
                >
                  <AntCard className="dashboard-card">
                    <div className="card-content">
                      <div className="card-icon">{item.icon}</div>
                      <div className="card-text">
                        <h2>{item.count}</h2>
                        <p>{item.label}</p>
                      </div>
                      <div className="card-footer">More Info ➡</div>
                    </div>
                  </AntCard>
                </Link>
              )}
            </AntCol>
          ))}
        </AntRow>

        <div className="cases-todo-section">
          <div className="info-card">
            <div className="card-header">
              <h3>
                <LiaClipboardListSolid />
                Today's Cases
              </h3>
            </div>

            <div className="mt-5" style={{ textAlign: 'end' }}>
              <button
                onClick={handleTaskClick}
                className="view-all-btn mb-2 mx-2"
              >
                <FaPlus />
                View All
              </button>
            </div>
          </div>
          <div className="info-card">
            <div className="card-header">
              <h3>
                <IoListSharp />
                Today's To Do
              </h3>
            </div>

            <div className="mt-5" style={{ textAlign: 'end' }}>
              <button className="view-all-btn mb-2 mx-2">
                <FaPlus />
                View All
              </button>
            </div>
          </div>
          <div className="info-card">
            <div className="card-header">
              <h3>
                <LiaClipboardListSolid />
                Notice Board
              </h3>
            </div>
            {/* <div className='card-content'>
              <p className='no-data-message'>No cases for today</p>
            </div> */}
            <div className=" notice-board-btn" style={{ textAlign: 'end' }}>
              <button className=" view-all-btn notice-board-btn  mb-2 mx-2 ">
                <FaPlus />
                View All
              </button>
            </div>
          </div>
          <div className="info-card d-flex flex-column gap-3 p-2">
            <div className="card-header">
              <h3>
                <IoPerson />
                Attendence
              </h3>
            </div>
            <div className="d-flex gap-2 ">
              <button className="card-btn1 px-4 rounded-md">
                <GiExitDoor />
                Mark In
              </button>
              <button className="card-btn2 py-2 px-4 rounded-md">
                <HiArrowSmUp />
                Apply Leave
              </button>
            </div>
            <div className="d-flex justify-content-between">
              <button className="card-btn3 py-2 px-4 rounded-md">
                <IoPerson />
                Attendence
              </button>
              <button className="view-all-btn mb-2 mx-2">
                <FaPlus />
                View All
              </button>
            </div>
          </div>
        </div>
        <div className="d-flex gap-2 mb-2">
          <div className="info-card w-25 Event-card">
            <div className="card-header">
              <h3>Events</h3>
            </div>
            <div className=" p-3 " style={{ textAlign: 'end' }}>
              <Form.Select className="mb-2" aria-label="Default select example">
                <option>en</option>
                <option value="1">Hindi</option>
                <option value="2">Arabic</option>
                <option value="3">Urdu</option>
              </Form.Select>
              <Button className="w-100 mb-2" variant="primary">
                Primary
              </Button>
              <Button className="w-100" variant="success">
                Appointments
              </Button>
            </div>
          </div>
          <div className="w-75 ">
            <Calendar onPanelChange={onPanelChange} />
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
